exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cta-form-container[data-v-15747085] {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n}\n.logo-1[data-v-15747085] {\n  margin-right: -15px;\n  z-index: 2;\n  border: solid 1px #DDD;\n  background: #FFF;\n  padding: 5px;\n}\n.logo-2[data-v-15747085] {\n  z-index: 1;\n}\n.logo-1[data-v-15747085], .logo-2[data-v-15747085] {\n  display: inline-flex;\n  width: 85px;\n  height: 85px;\n  border-radius: 50%;\n}", ""]);

// exports
